module.exports = __webpack_public_path__ + "img/22.d932315c.png";